import { render, staticRenderFns } from "./Member2.vue?vue&type=template&id=5e11fb72"
import script from "./Member2.vue?vue&type=script&lang=js"
export * from "./Member2.vue?vue&type=script&lang=js"
import style0 from "./Member2.vue?vue&type=style&index=0&id=5e11fb72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports